import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";

export interface AcademyRedirectParams {
  Locale?: string;
}

export interface AcademyRedirectResponse {
  redirectUrl: string;
  callResults?: unknown[];
  error?: string | null;
}

export const academyAPI = createApi({
  reducerPath: "academyAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getAcademyRedirectUrl: builder.query<AcademyRedirectResponse, AcademyRedirectParams>({
      query: (params) => {
        const { Locale } = params;
        const queryParams = new URLSearchParams();
        if (Locale) queryParams.append("Locale", Locale.toLowerCase());
        return `/redirect?${queryParams}`;
      },
      extraOptions: { pathKey: "academy" },
    }),
  }),
});

export const { useLazyGetAcademyRedirectUrlQuery } = academyAPI;
